module.exports = __webpack_public_path__ + "static/media/icon_minus_2.8bcc7ef4.svg";